import { render, staticRenderFns } from "./knowledgehub.vue?vue&type=template&id=61bd4fd6&"
import script from "./knowledgehub.vue?vue&type=script&lang=js&"
export * from "./knowledgehub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports